// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

const CORE_NAMESPACE_LIST = ["common", "titles", "tables"];
const CORE_NAMESPACES = new Set(CORE_NAMESPACE_LIST);

function firstI18nPart(value: string | readonly string[]) {
  return Array.isArray(value) ? value[0] : value;
}

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    defaultNS: "common",
    ns: CORE_NAMESPACE_LIST,
    backend: {
      loadPath: (
        lngs: string | readonly string[],
        namespaces: string | readonly string[],
      ) => {
        const lng = firstI18nPart(lngs);
        const namespace = firstI18nPart(namespaces);

        if (CORE_NAMESPACES.has(namespace)) {
          return `/locales/${lng}/${namespace}.json`;
        }

        return `/locales/${lng}/tables/${namespace}.json`;
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
